import { Button, Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Stack, Text } from '@chakra-ui/react';
import { FaStore } from 'react-icons/fa';
import { FiMoreVertical } from 'react-icons/fi';
import { MdAttachMoney, MdMoneyOff, MdTimer } from 'react-icons/md';
import {
  RiArrowRightLine,
  RiMap2Line,
  RiPhoneLine,
  RiProfileLine,
  RiUser3Line,
} from 'react-icons/ri';
import { SiIfood } from 'react-icons/si';

type SortData = {
	por: string;
	cres: boolean;
};
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};
type TotalsData = {
	custo: string;
	entrega: string;
	troco: string;
};
type EntregaData = {
	id_entrega: number;
	id_loja: number;
	id_venda: number;
	id_entregador: number;
	nome_entregador: string;
	nome_cliente: string;
	tipo_venda: string;
	data_venda: string;
	data_entrega: string;
	data_previsao: string;
	atraso: string;
	tempo: string;
	obs_entrega: string;
	pago: string;
	evento: string;
	motivo: string;
	vlr_custo: number;
	vlr_entrega: number;
	vlr_troco: number;
	vlr_total: number;
	vlr_custoFormatted: string;
	vlr_entregaFormatted: string;
	vlr_trocoFormatted: string;
	vlr_totalFormatted: string;
};
interface DataTableCardsParams {
	entregas: EntregaData[];
	pesqEntregas: EntregaData[];
	totals: TotalsData;
	sort: SortData;
	setSort: (sort: SortData) => void;
	controls: ControlsData;
	handleUpdateList: (
		page: number,
		perPage: number,
		entregas: EntregaData[],
	) => void;
	setEntregaModal: (entrega: EntregaData) => void;
	setModalEntregaVisible: (visible: boolean) => void;
}

const DataTableCards: React.FC<DataTableCardsParams> = ({
	entregas,
	pesqEntregas,
	totals,
	sort,
	setSort,
	controls,
	handleUpdateList,
	setEntregaModal,
	setModalEntregaVisible
}) => {
  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
      {entregas.map(entrega => {
        return (
          <Flex
						key={entrega.id_entrega}
            justify="space-between"
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
            m="4"
          >
						<Flex w="100%">
              <Stack w="100%" spacing={1}>
                {entrega.id_venda && (
                  <Flex align="center">
										<Text color="#1a83ff" fontWeight="bold">
											{entrega.id_venda}
										</Text>
										{entrega.tipo_venda === 'IFood' ? (
											<Icon as={SiIfood} ml={2} color="#c53030" />
										) : (
											<Icon as={FaStore} ml={2} color="#1a83ff" />
										)}
                  </Flex>
                )}

								{entrega.nome_entregador && (
                  <Flex align="center">
                    <Text color="gray.600" fontSize="14" fontWeight="500">
											{entrega.nome_entregador}
                    </Text>
                  </Flex>
                )}

								{entrega.nome_cliente && (
									<Flex align="center">
										<Icon as={RiUser3Line} color="gray.600" fontSize="16" mr="1" />
										<Text color="gray.600" fontSize="14" fontWeight="500">
											{entrega.nome_cliente}
										</Text>
									</Flex>
								)}

								{entrega.data_entrega && (
                  <Flex align="center">
										<Text color="gray.600" fontSize="14" fontWeight="500">
											Entrega: {entrega.data_entrega}
                    </Text>
                  </Flex>
                )}

								{entrega.data_previsao && (
                  <Flex align="center">
										<Text color="gray.600" fontSize="14" fontWeight="500">
											Previsão: {entrega.data_previsao}
                    </Text>
                  </Flex>
                )}

								{entrega.tempo && (
									<Flex align="center">
										<Icon
											as={MdTimer}
											color={entrega.atraso === 'Sim' ? '#c53030' : '#1B5E20'}
											fontSize={20}
											mr={1}
										/>
										<Text color="gray.600" fontSize="14" fontWeight="500">
											{entrega.tempo}
										</Text>

										{entrega.pago && (
											<>
												<Text color="gray.600" fontSize="14" fontWeight="500" ml={4}>
													Pago: 
												</Text> 
												<Icon
													as={entrega.pago === 'N' ? MdMoneyOff : MdAttachMoney}
													color={entrega.pago === 'N' ? "#c53030" : "#1B5E20"}
													fontSize={20}
												/>
											</>
										)}
									</Flex>
								)}

								{entrega.vlr_custoFormatted && (
									<Flex align="center">
										<Text color="gray.600" fontSize="14" fontWeight="500">
											Vlr: Custo: {entrega.vlr_custoFormatted}
										</Text>
									</Flex>
								)}

								{entrega.vlr_trocoFormatted && (
									<Flex align="center">
										<Text color="gray.600" fontSize="14" fontWeight="500">
											Vlr. Troco: {entrega.vlr_trocoFormatted}
										</Text>
									</Flex>
								)}

								<Flex w="100%" justify="space-between">
									{entrega.vlr_entregaFormatted && (
										<Flex align="center">
											<Text color="gray.600" fontSize="14" fontWeight="500">
												Vlr. Entrega: {entrega.vlr_entregaFormatted}
											</Text>
										</Flex>
									)}

									<Menu isLazy>
										{({ isOpen }) => (
											<>
												<MenuButton
													as={IconButton}
													fontSize={["1.6rem", "2rem"]}
													isActive={isOpen}
													icon={<FiMoreVertical />}
													_hover={{ bg: 'gray.50' }}
													_expanded={{ bg: 'gray.100' }}
													css={{ '-webkit-tap-highlight-color': 'transparent' }}
													py="-2px"
												/>

												<MenuList p={0} boxShadow='xl'>
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{
															bg: 'gray.50'
														}}
														onClick={() => {
															setEntregaModal(entrega);
															setModalEntregaVisible(true);
														}}
													>
														Detalhes
													</MenuItem>

													<MenuItem 
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{
															bg: 'gray.50'
														}}
														isDisabled={true}
													>
														Editar
													</MenuItem>
												</MenuList>
											</>
										)}
									</Menu>
								</Flex>
              </Stack>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DataTableCards;
